/* eslint-disable @bigbinary/neeto/use-webpack-alias */
import { Close } from "@bigbinary/neeto-icons";
import { Typography, Button } from "@bigbinary/neetoui";
import { manager } from "@bigbinary/neetoui/managers";
import classnames from "classnames";
import useHotkeys from "neetohotkeys";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import HotKeyList from "./HotKeyList";
import "./keyboard-shortcuts.scss";
import { getGlobalShortcuts } from "./utils";

import useKeyboardShortcutsPaneState from "../hooks/useKeyboardShortcutsPaneState";

const KeyboardShortcutsPane = ({ productShortcuts = {} }) => {
  const [isOpen, setIsOpen] = useKeyboardShortcutsPaneState();
  const hasOverlays = manager.hasOverlays();
  // eslint-disable-next-line @bigbinary/neeto/no-dangling-constants
  const GLOBAL_SHORTCUTS = getGlobalShortcuts();
  const { t } = useTranslation();

  const shortcuts =
    GLOBAL_SHORTCUTS[t("neetoMolecules.keyboardShortcuts.global.categoryName")];

  useHotkeys(
    shortcuts.openKeyboardShortcutsPane.sequence,
    () => setIsOpen(prevIsOpen => !prevIsOpen),
    { mode: "global" }
  );

  useHotkeys(shortcuts.close.sequence, () => setIsOpen(false), {
    mode: "global",
    enabled: isOpen,
  });

  return (
    <div
      data-testid="keyboard-shortcuts-pane"
      className={classnames(
        "neeto-molecules-keyboard-shortcuts-pane neeto-ui-border-gray-300 transition-width neeto-ui-bg-white ms-auto h-dvh overflow-hidden border-l duration-300 ease-in-out rtl:border-l-0 rtl:border-r",
        {
          "w-80": isOpen,
          "w-0": !isOpen,
          absolute: hasOverlays,
          "end-0": hasOverlays,
        }
      )}
    >
      <div className="h-full w-80 overflow-y-auto">
        <div className="neeto-ui-border-gray-300 my-2 flex items-center justify-between border-b px-4 pb-2">
          <Typography data-testid="keyboard-shortcuts-pane-title" style="h4">
            {t("neetoMolecules.keyboardShortcuts.title")}
          </Typography>
          <Button
            data-testid="keyboard-shortcuts-pane-close-button"
            icon={Close}
            style="text"
            onClick={() => setIsOpen(false)}
          />
        </div>
        <HotKeyList hotkeys={GLOBAL_SHORTCUTS} />
        <HotKeyList hotkeys={productShortcuts} />
      </div>
    </div>
  );
};

KeyboardShortcutsPane.propTypes = {
  /**
   * Used to pass in the product specific keyboard shortcuts.
   */
  productShortcuts: PropTypes.object,
};

export default KeyboardShortcutsPane;
